import { createSelector, createSlice } from '@reduxjs/toolkit';

export interface IEditQuestionModalsState {
  isCopyQueryOpen: boolean;
  isSubQueryDepListOpen: boolean;
  isRuntimeSettingsOpen: boolean;
  isAddConceptOpen: boolean;
  isQuestionWideFiltersOpen: boolean;
}

export const initialState: IEditQuestionModalsState = {
  isCopyQueryOpen: false,
  isSubQueryDepListOpen: false,
  isRuntimeSettingsOpen: false,
  isAddConceptOpen: false,
  isQuestionWideFiltersOpen: false,
};

export const editQuestionModalsReducer = {
  resetState: (state: IEditQuestionModalsState) => {
    state.isCopyQueryOpen = initialState.isCopyQueryOpen;
    state.isSubQueryDepListOpen = initialState.isSubQueryDepListOpen;
    state.isRuntimeSettingsOpen = initialState.isRuntimeSettingsOpen;
    state.isAddConceptOpen = initialState.isAddConceptOpen;
    state.isQuestionWideFiltersOpen = initialState.isQuestionWideFiltersOpen;
  },

  openCopyQuery: (state: IEditQuestionModalsState) => {
    state.isCopyQueryOpen = true;
  },

  closeCopyQuery: (state: IEditQuestionModalsState) => {
    state.isCopyQueryOpen = false;
  },

  openSubQueryDepList: (state: IEditQuestionModalsState) => {
    state.isSubQueryDepListOpen = true;
  },

  closeSubQueryDepList: (state: IEditQuestionModalsState) => {
    state.isSubQueryDepListOpen = false;
  },

  openRuntimeSettings: (state: IEditQuestionModalsState) => {
    state.isRuntimeSettingsOpen = true;
  },

  closeRuntimeSettings: (state: IEditQuestionModalsState) => {
    state.isRuntimeSettingsOpen = false;
  },

  openAddConcept: (state: IEditQuestionModalsState) => {
    state.isAddConceptOpen = true;
  },

  closeAddConcept: (state: IEditQuestionModalsState) => {
    state.isAddConceptOpen = false;
  },

  openQuestionWideFilters: (state: IEditQuestionModalsState) => {
    state.isQuestionWideFiltersOpen = true;
  },

  closeQuestionWideFilters: (state: IEditQuestionModalsState) => {
    state.isQuestionWideFiltersOpen = false;
  },
};

export const editQuestionModalsSlice = createSlice({
  name: 'toolbarModalsSlice',
  initialState,
  reducers: editQuestionModalsReducer,
});

export const {
  resetState,
  openCopyQuery,
  closeCopyQuery,
  openSubQueryDepList,
  closeSubQueryDepList,
  openRuntimeSettings,
  closeRuntimeSettings,
  openAddConcept,
  closeAddConcept,
  openQuestionWideFilters,
  closeQuestionWideFilters,
} = editQuestionModalsSlice.actions;

export default editQuestionModalsSlice.reducer;

// selectors
export const selectIsADependencyModalOpen = createSelector(
  [
    (state) => state.editQuestionModals.isQuestionWideFiltersOpen,
    (_isQuestionWideFiltersOpen, state) => state.editQuestionModals.isRuntimeSettingsOpen,
    (_isEditQuestionModals, _isRuntimeSettingsOpen, isCalcsModalOpen) => isCalcsModalOpen,
  ],
  (isQuestionWideFiltersOpen, isRuntimeSettingsOpen, isCalcsModalOpen) =>
    isQuestionWideFiltersOpen || isRuntimeSettingsOpen || isCalcsModalOpen
);
